import { useEffect, useState } from 'react';

import type { TUseExternalScriptState } from './externalScript.hook.type';

/**
 * For the specified URL, adds a <script async> tag in the HTML and asynchronously loads the external script
 */
export const useExternalScript = (url: string): TUseExternalScriptState => {
  const [state, setState] = useState<TUseExternalScriptState>(url ? 'loading' : 'idle');

  useEffect(() => {
    if (url) {
      let script = <HTMLScriptElement>document.querySelector(`script[src="${url}"]`);

      const handleScript = (event: Event) => {
        setState(event.type === 'load' ? 'ready' : 'error');
      };

      script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.async = true;
      document.body.appendChild(script);
      script.addEventListener('load', handleScript);
      script.addEventListener('error', handleScript);

      setState('ready');

      script.addEventListener('load', handleScript);
      script.addEventListener('error', handleScript);

      return () => {
        script.removeEventListener('load', handleScript);
        script.removeEventListener('error', handleScript);
      };
    }

    return undefined;
  }, [url]);

  return state;
};
